import React, { useContext, useEffect } from 'react'
import Style from './Layout.module.css'
import { Outlet } from 'react-router-dom'
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { Offline } from 'react-detect-offline';
import { CartContext } from '../../context/CartContext';


export default function Layout() {

  const { getLoggedInUserCart, setCartCount } = useContext(CartContext);

  const getCartCount = async () => {

    try {
      const { data } = await getLoggedInUserCart();
      setCartCount(data.numOfCartItems);
    } catch (error) {
      setCartCount(0)
    }

  }

  useEffect(() => {
    getCartCount()
  }, [])

  return (
    <>
      <Navbar />
      <div className="container">
        <Outlet />
      </div>
      <div className="offline"><Offline ><i className='fas fa-wifi px-2'></i>You Are Offline!</Offline></div>
    </>
  )
}
